/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wsc_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per-line steps run first — collapse spaces and trim each line — then blank lines are removed, and finally the whole result is trimmed if that option is on. The toggles are independent, so you can enable any combination.`)
};

const es_wsc_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los pasos por línea se ejecutan primero — colapsar espacios y recortar cada línea — luego se eliminan las líneas en blanco, y finalmente se recorta todo el resultado si esa opción está activada. Los alternadores son independientes, por lo que puedes activar cualquier combinación.`)
};

const de_wsc_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeilenweise Schritte laufen zuerst ab — Leerzeichen zusammenfassen und jede Zeile trimmen —, dann werden Leerzeilen entfernt, und schließlich wird das gesamte Ergebnis getrimmt, falls diese Option aktiviert ist. Die Schalter sind unabhängig voneinander, sodass Sie jede beliebige Kombination aktivieren können.`)
};

const nl_wsc_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stappen per regel worden eerst uitgevoerd — spaties samenvouwen en elke regel bijsnijden — vervolgens worden lege regels verwijderd, en ten slotte wordt het hele resultaat bijgesneden als die optie aanstaat. De schakelaars zijn onafhankelijk, dus u kunt elke combinatie inschakelen.`)
};

const fr_wsc_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les étapes par ligne s'exécutent d'abord — réduire les espaces et supprimer les espaces de chaque ligne — puis les lignes vides sont supprimées, et enfin le résultat entier est supprimé si cette option est activée. Les bascules sont indépendantes, vous pouvez donc activer n'importe quelle combinaison.`)
};

const it_wsc_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I passaggi per riga vengono eseguiti per primi — comprimi spazi e taglia ogni riga — quindi le righe vuote vengono rimosse e infine l'intero risultato viene tagliato se tale opzione è attivata. Gli interruttori sono indipendenti, quindi puoi abilitare qualsiasi combinazione.`)
};

const pt_br2_wsc_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os passos por linha são executados primeiro — colapsar espaços e aparar cada linha — depois as linhas em branco são removidas, e finalmente o resultado inteiro é aparado se essa opção estiver ativada. Os alternadores são independentes, portanto você pode ativar qualquer combinação.`)
};

const pt_wsc_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os passos por linha são executados primeiro — colapsar espaços e aparar cada linha — depois as linhas em branco são removidas, e finalmente o resultado completo é aparado se essa opção estiver ativada. Os interruptores são independentes, portanto pode ativar qualquer combinação.`)
};

const ja_wsc_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライン単位のステップが最初に実行され — スペースを圧縮して各行をトリム — その後空白行が削除され、最後にそのオプションがオンの場合、全体結果がトリムされます。トグルは独立しており、任意の組み合わせを有効にできます。`)
};

const zh_wsc_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`逐行处理的步骤会先执行 — 合并空格和修剪每一行 — 然后删除空行，最后如果启用了该选项，则修剪整个结果。这些开关相互独立，因此您可以启用任意组合。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wsc_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wsc_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wsc_faq4_a", locale)
	if (locale === "en") return en_wsc_faq4_a(inputs)
	if (locale === "es") return es_wsc_faq4_a(inputs)
	if (locale === "de") return de_wsc_faq4_a(inputs)
	if (locale === "nl") return nl_wsc_faq4_a(inputs)
	if (locale === "fr") return fr_wsc_faq4_a(inputs)
	if (locale === "it") return it_wsc_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_wsc_faq4_a(inputs)
	if (locale === "pt") return pt_wsc_faq4_a(inputs)
	if (locale === "ja") return ja_wsc_faq4_a(inputs)
	return zh_wsc_faq4_a(inputs)
};